// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    setLoading(true);
    try {
        const response = await fetch('/api/password-reset/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (!response.ok) {
        setError(data.email || 'Error sending reset link.');
      } else {
        // Ответ одинаковый для любого адреса — не подсказываем, зарегистрирован ли он.
        setMessage('If that email is registered, a reset link has been sent.');
        setEmail('');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen font-sans">
      {/* Header (same as Login) */}
      <nav className="bg-[#0F2C5E] text-white p-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img src="/logo.png" alt="Logo" className="h-8 w-8" />
          <span className="font-bold text-xl">2290Pay.org</span>
        </div>
        <div className="space-x-6">
          {/* empty for spacing */}
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center bg-[#E4F2FF] p-4">
        <div className="bg-white w-full max-w-md p-8 shadow-md rounded-md space-y-6">
          <h1 className="text-2xl font-bold text-[#0F2C5E] text-center">
            Forgot Password
          </h1>
          <p className="text-gray-600 text-sm text-center">
            Enter your email address below and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-[#0F2C5E] mb-1 text-sm font-medium">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#0F2C5E] text-sm"
              />
            </div>

            {error && <p className="text-red-500 text-sm">{error}</p>}
            {message && <p className="text-green-600 text-sm">{message}</p>}

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#0F2C5E] text-white py-2 rounded-md text-sm hover:bg-[#0F2C5E]/80 transition ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
          <div className="text-center text-sm">
            <Link to="/sign-in" className="text-[#0F2C5E] hover:underline">
              Back to Login
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
